import { Button } from "@portal/BaseComponents/Button/AntButton";
import { DateText } from "@portal/BaseComponents/Date/DateText";
import { Dropdown } from "@portal/BaseComponents/Dropdown/AntDropdown";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { MenuInfo } from "@portal/BaseComponents/Menu/type";
import { notify } from "@portal/BaseComponents/Notifications";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { downloadDocumentTypes } from "@portal/hooks/useDownlodDocument";
import { GF_URL } from "@portal/lib/ky/type";
import { FileType } from "@portal/types/file";
import { Typography } from "antd";
import dayjs from "dayjs";
import {
  DownloadStatementFilter,
  SuffixIcon,
  t,
} from "../PopOver/StatementContent";
import { downloadOptions } from "../predicte";

interface OutStandingTransactionsProps {
  customerId?: string;
  download: downloadDocumentTypes<DownloadStatementFilter>["downloadCallback"];
  onClose: () => void;
  url: GF_URL;
}

function OutStandingTransactions(
  props: Readonly<OutStandingTransactionsProps>
) {
  async function triggerDownload(fileType: FileType) {
    props.onClose();
    try {
      const DATE_FORMAT = "YYYY-MM-DD";

      await props.download(props.url, {
        data: {
          file_type: fileType,
          date: dayjs()?.format(DATE_FORMAT),
          transaction_type: "OUTSTANDING",
        },
      });
    } catch {
      notify.error(t.notify.failure);
    }
  }

  function handleMenuClick(event: MenuInfo) {
    triggerDownload(event.key as FileType);
  }

  const DownloadButton = (
    <Dropdown
      menu={{ items: downloadOptions, onClick: handleMenuClick }}
      trigger={["click"]}
    >
      <Button size="middle" type="primary">
        <Flex align="center" justify="space-between" space="12">
          {t.download}
          {SuffixIcon}
        </Flex>
      </Button>
    </Dropdown>
  );

  return (
    <>
      <Flex vertical space="12" style={{ width: "100%" }}>
        <Flex vertical space="4">
          <TypographyText strong>Outstanding Transactions</TypographyText>
          <Typography>
            as of <DateText value="" currentDate textProps={{ strong: true }} />
          </Typography>
        </Flex>
        <div>{DownloadButton}</div>
      </Flex>
    </>
  );
}

export { OutStandingTransactions };
